<template>
  <v-layout row wrap class="trail-balance">
    <v-flex xs12 sm12 md12>
      <v-toolbar  class="mb" color="primary" dark  flat>
        <!-- <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link> -->
        <v-flex xs12 sm2 md2>  
          <h2 class="font-weight-light headline">
            Trail Balance
          </h2>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 sm2 md2>
          <v-switch
            class="filter-switch1"
            v-model="detailedView"
            :label="`Enlarge View: ${detailedView ? 'Yes' : 'No'}`"
          ></v-switch>
        </v-flex>
      </v-toolbar>  
      <v-toolbar class="mb" color="white white--text" flat>
        <v-flex xs12 sm4 md4>
          <v-select
            item-text="name"
            return-object
            :items="firmsByBrand"
            label="Select Firm"
            v-model="selectedFirm"
            clearable
          ></v-select>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 sm3 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerFrom"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="fromDate"
              label="From Date"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 sm3 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerTo"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="toDate"
              label="To Date"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-toolbar>
      <!-- <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm4 md4>
              <template v-if="selectedFirm">
                Firm name :
                <b>{{selectedFirm.name}}</b>
                <br />
                GSTIN :
                <b>{{selectedFirm.GST_number}}</b>
                <v-btn flat @click="printGST3()">Print</v-btn>
                <v-btn flat type="button" @click="onexport()">Excel</v-btn>
              </template>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <template v-if="fromDate">
                Selected From Date :
                <b class="font-weight-bold">{{new Date(fromDate).toLocaleDateString('en-GB')}}</b>
                <br />
              </template>
              <template v-if="toDate">
                Selected To Date :
                <b class="font-weight-bold">{{new Date(toDate).toLocaleDateString('en-GB')}}</b>
              </template>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <template v-if="selectedFirm">
                Address :
                <b>{{generateAddress(selectedFirm)}}</b>
                <br/>
                Mobile :
                <b>{{selectedFirm.mobileNumber}}</b>
                <br />
                Email :
                <b>{{selectedFirm.email}}</b>
                <br />
                <v-btn flat @click="printGST3()">Print</v-btn>
                <v-btn flat type="button" @click="onexport()">Excel</v-btn>
              </template>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card> -->
      <v-layout row wrap>
        <v-flex xs12>
          <table class="fl2-table">
            <thead>
              <tr>
                <th rowspan="2">S.No</th>
                <th rowspan="2">DESCRIPTION</th>
                <th :colspan="detailedView ? 4 : 2">BALANCE</th>
              </tr>

              <tr>
                <th v-if="detailedView" style="text-align: right;">OPENING</th>
                <th>DEBIT</th>
                <th>CREDIT</th>
                <th v-if="detailedView" style="text-align: right;">CLOSING</th>
              </tr>
            
            </thead>
            <tbody>
                <tr>
                    <td><h3>1</h3>
                        <span style="display: grid;">
                            <v-icon v-if="!firmObj.expand" @click="toggle(firmObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="firmObj.expand" @click="toggle(firmObj)" color="primary">expand_less</v-icon>
                        </span>
                    </td>
                    <td style="text-align: left;"><h3> PROP CAPITAL ACCOUNT</h3></td>
                    <td style="text-align: right;" v-if="detailedView" >{{firmObj.total || 0 | amount }}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{firmObj.total || 0 | amount }}</h3></td>
                    <td style="text-align: right;" v-if="detailedView">{{getClosingBalance(firmObj.total,0,firmObj.total) || 0 | amount}}</td>
                </tr>
                <template v-if="firmObj.expand">
                  <template v-for="firm of firmObj.list" >
                    <tr v-bind:key="firm['.key']">
                      <td></td>
                      <td style="text-align: left;"><h4>{{firm.name}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;">{{firm.openingBalance || 0 | amount }}</td>
                      <td></td>
                      <td style="text-align: right;"><b class="red--text"><h4> {{firm.openingBalance || 0 | amount }}</h4></b></td>
                      <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(firm.openingBalance,0,firm.openingBalance) || 0 | amount}}</td>
                    </tr>
                  </template>
                </template>
                
                <!-- Start of Loan and Advances -->  
                <tr>
                    <td><h3>2</h3>
                        <span style="display: grid;">
                            <v-icon v-if="!loanObj.expand" @click="toggle(loanObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="loanObj.expand" @click="toggle(loanObj)" color="primary">expand_less</v-icon>
                        </span>
                    </td>
                    <td style="text-align: left;"><h3>LOANS</h3></td>
                     <td v-if="detailedView" style="text-align: right;">{{(securedLoansBankListTotalOpening + totalUnsecuredLoanOpening) || 0 | amount}}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{securedLoansBankListTotal + totalLoan || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance((securedLoansBankListTotalOpening + totalUnsecuredLoanOpening),0,(securedLoansBankListTotal+totalLoan)) || 0 | amount}}</td>
                </tr>
                <template v-if="loanObj.expand">
                  <tr>
                    <td><h3></h3>
                      <span style="display: grid;">
                        <v-icon v-if="!loanObj.securedLoanObj.expand" @click="toggle(loanObj.securedLoanObj)" color="primary">expand_more</v-icon>
                        <v-icon v-if="loanObj.securedLoanObj.expand" @click="toggle(loanObj.securedLoanObj)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    <td style="text-align: left;"><h3>Secured Loans</h3></td>
                     <td v-if="detailedView" style="text-align: right;">{{(securedLoansBankListTotalOpening ) || 0 | amount}}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{securedLoansBankListTotal || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance((securedLoansBankListTotalOpening),0,(securedLoansBankListTotal)) || 0 | amount}}</td>
                </tr>
                <template v-if="loanObj.securedLoanObj.expand">
                    <template v-for="bank in securedLoansBankList" >
                    <tr v-bind:key="bank['.key']" >
                        <td></td>
                        <td style="text-align: left;"><h4>{{bank.bankName}}</h4></td>
                         <td v-if="detailedView" style="text-align: right;"> {{bank.openingBalance || 0 | amount}}</td>
                        <td></td>
                        <td style="text-align: right;"><b class="red--text"><h4> {{bank.amount || 0 | amount }}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(bank.openingBalance,0,bank.amount) || 0 | amount}}</td>
                      </tr> 
                    </template>
                  </template>
                </template>
                <template v-if="loanObj.expand">
                  <tr>
                    <td><h3></h3>
                        <span style="display: grid;">
                            <v-icon v-if="!loanObj.unsecuredLoanObj.expand" @click="toggle(loanObj.unsecuredLoanObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="loanObj.unsecuredLoanObj.expand" @click="toggle(loanObj.unsecuredLoanObj)" color="primary">expand_less</v-icon>
                        </span>
                    </td>
                    <td style="text-align: left;"><h3>Unsecured Loans</h3></td>
                     <td v-if="detailedView" style="text-align: right;">{{totalUnsecuredLoanOpening || 0 | amount}}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{totalLoan || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalUnsecuredLoanOpening,0,totalLoan) || 0 | amount}}</td>
                </tr>
               <template v-if="loanObj.unsecuredLoanObj.expand">
                  <template v-for="creditor in sellerList.concat(buyerList)" >
                    <tr v-if="!!creditor.totalLoanGiven" :key="creditor['.key']">
                      <td></td>
                      <td style="text-align: left;"><h4>{{creditor['name']}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;">{{creditor.totalOpeningBal || 0 | amount}}</td>
                      <td></td>
                      <td style="text-align: right;"><b class="red--text"><h4> {{creditor.totalLoanGiven || 0 | amount }}</h4></b></td>
                      <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(creditor.totalOpeningBal,0,creditor.totalLoanGiven) || 0 | amount}}</td>
                    </tr> 
                  </template>
                </template>
              </template>
              <!-- End of Loans --> 
                

              <!-- Start of Current Liabilities --> 
              <tr>
                <td><h3>3</h3>
                  <span style="display: grid;">
                    <v-icon v-if="!liabilitiesObj.expand" @click="toggle(liabilitiesObj)" color="primary">expand_more</v-icon>
                    <v-icon v-if="liabilitiesObj.expand" @click="toggle(liabilitiesObj)" color="primary">expand_less</v-icon>
                  </span>
                </td>
                <td><h3 style="text-align: left;">CURRENT LIABILIITIES</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(totalUnsecuredLoanOpening) + Number.parseFloat(provisionOpeningBal) + Number.parseFloat(liabilityOpeningBalanace) || 0 | amount}}</td>
                  <td></td>
                  <td style="text-align: right;"><h3 class="red--text"> {{(Number.parseFloat(liabilityTotal) + Number.parseFloat(totalSundryCreditors) + Number.parseFloat(expenseTotal) + Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) | amount}}</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{getClosingBalance((Number.parseFloat(totalUnsecuredLoanOpening) + Number.parseFloat(provisionOpeningBal) +Number.parseFloat(liabilityOpeningBalanace)),0,(Number.parseFloat(liabilityTotal) + Number.parseFloat(totalSundryCreditors) + Number.parseFloat(expenseTotal) + Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST))) || 0 | amount}}</td>
              </tr>
              <template v-if="liabilitiesObj.expand">
                <tr>
                  <td><h3></h3>
                    <span style="display: grid;">
                      <v-icon v-if="!liabilitiesObj.sundryCreditorsObj.expand" @click="toggle(liabilitiesObj.sundryCreditorsObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="liabilitiesObj.sundryCreditorsObj.expand" @click="toggle(liabilitiesObj.sundryCreditorsObj)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>Sundry Creditors</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalUnsecuredLoanOpening || 0 | amount}}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{totalSundryCreditors || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalUnsecuredLoanOpening,0,totalSundryCreditors) || 0 | amount}}</td>
                </tr>

                <template v-if="liabilitiesObj.sundryCreditorsObj.expand">
                  <template v-for="creditor in sellerList" >
                    <tr v-if="!!creditor.totalRemainingAmount" v-bind:key="creditor['.key']" >
                      <td></td>
                      <td style="text-align: left;"><h4>{{creditor['name']}}</h4></td>
                       <td v-if="detailedView" style="text-align: right;">{{creditor.totalOpeningBal || 0 | amount}}</td>
                      <td></td>
                      <td style="text-align: right;"><b class="red--text"><h4> {{creditor.totalRemainingAmount || 0 | amount}}</h4></b></td>
                       <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(creditor.totalOpeningBal,0,creditor.totalRemainingAmount) || 0 | amount}}</td>
                    </tr> 
                    </template>
                  </template>
                </template>


                <template v-if="liabilitiesObj.expand">
                  <tr>
                    <td><h3></h3>
                        <span style="display: grid;">
                            <v-icon v-if="!liabilitiesObj.provisionObj.expand" @click="toggle(liabilitiesObj.provisionObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="liabilitiesObj.provisionObj.expand" @click="toggle(liabilitiesObj.provisionObj)" color="primary">expand_less</v-icon>
                        </span>
                    </td>
                    <td style="text-align: left;"><h3>Provisions</h3></td>
                     <td v-if="detailedView" style="text-align: right;">{{provisionOpeningBal || 0 | amount }}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{expenseTotal || 0 | amount}}</h3></td>
                     <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(provisionOpeningBal,0,expenseTotal) || 0 | amount}}</td>
                </tr>
                <template v-if="liabilitiesObj.provisionObj.expand">
                    <template v-for="expense in expensesWPro" >
                    <tr v-if="expense.paymentTypeStatus === 'yet to confirm' && expense.totalAmount > 0" v-bind:key="expense['.key']"  >
                        <td></td>
                        <td style="text-align: left;"><h4>{{expense.expense}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;">{{expense.openingBalance || 0 | amount }}</td>
                        <td></td>
                        <td style="text-align: right;"><b class="red--text"><h4> {{expense.totalAmount || 0 | amount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(expense.openingBalance,0,expense.totalAmount) || 0 | amount}}</td>
                    </tr> 
                    </template>
                </template>
                </template>

                
                <template v-if="liabilitiesObj.expand">
                  <tr>
                    <td><h3></h3>
                      <span style="display: grid;">
                        <v-icon v-if="!liabilitiesObj.liabilitiesObj.expand" @click="toggle(liabilitiesObj.liabilitiesObj)" color="primary">expand_more</v-icon>
                        <v-icon v-if="liabilitiesObj.liabilitiesObj.expand" @click="toggle(liabilitiesObj.liabilitiesObj)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    <td style="text-align: left;"><h3>Liabilities</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{liabilityOpeningBalanace || 0 | amount}}</td>
                    <td></td>
                    <td style="text-align: right;"><h3 class="red--text"> {{liabilityTotal || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(liabilityOpeningBalanace,0,liabilityTotal) || 0 | amount}}</td>
                  </tr>
                  <template v-if="liabilitiesObj.liabilitiesObj.expand">
                    <template v-for="liability in liabilitiesWPro">
                      <tr v-if="liability.paymentTypeStatus === 'yet to confirm' && (liability.totalAmount || liability.openingBalance )> 0" v-bind:key="liability['.key']"  >
                        <td></td>
                        <td style="text-align: left;"><h4>{{liability.liability}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;">{{liability.openingBalance || 0 | amount}}</td>
                        <td></td>
                        <td style="text-align: right;"><b class="red--text"><h4> {{Number.parseFloat(liability.totalAmount + liability.openingBalance) || 0 | amount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(liability.openingBalance,0,Number.parseFloat(liability.totalAmount + liability.openingBalance)) || 0 | amount}}</td>
                      </tr> 
                    </template>
                  </template>
                  </template>
                  
                  <template v-if="liabilitiesObj.expand">
                      <tr>
                        <td><h3></h3>
                          <span style="display: grid;">
                            <v-icon v-if="!liabilitiesObj.gstObj.expand" @click="toggle(liabilitiesObj.gstObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="liabilitiesObj.gstObj.expand" @click="toggle(liabilitiesObj.gstObj)" color="primary">expand_less</v-icon>
                          </span>
                        </td>
                        <td style="text-align: left;"><h3>Payable</h3></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                        <td></td>
                        <td style="text-align: right;"><h3 class="red--text"> {{(Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) || 0 | amount}}</h3></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                      </tr>
                      <template v-if="liabilitiesObj.gstObj.expand">
                        <template>
                          <tr>
                            <td></td>
                            <td style="text-align: left;"><h4>IGST</h4></td>
                            <td v-if="detailedView" style="text-align: right;"></td>
                            <td></td>
                            <td style="text-align: right;"><b class="red--text"><h4> {{ITCData.liabilities.IGST || 0 | amount}}</h4></b></td>
                            <td v-if="detailedView" style="text-align: right;"></td>
                          </tr> 
                        </template>
                      <template>
                        <tr>
                          <td></td>
                          <td style="text-align: left;"><h4>CGST</h4></td>
                          <td v-if="detailedView" style="text-align: right;"></td>
                          <td></td>
                          <td style="text-align: right;"><b class="red--text"><h4> {{ITCData.liabilities.CGST || 0 | amount}}</h4></b></td>
                          <td v-if="detailedView" style="text-align: right;"></td>
                        </tr> 
                      </template>
                      <template>
                        <tr>
                          <td></td>
                          <td style="text-align: left;"><h4>SGST</h4></td>
                          <td v-if="detailedView" style="text-align: right;"></td>
                          <td></td>
                          <td style="text-align: right;"><b class="red--text"><h4> {{ITCData.liabilities.SGST || 0 | amount}}</h4></b></td>
                          <td v-if="detailedView" style="text-align: right;"></td>
                        </tr> 
                      </template>
                    </template>
                  </template>

                <!-- Start of Loan and Advances -->  
                <tr>
                  <td><h3>4</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!loanAdvancesObj.expand" @click="toggle(loanAdvancesObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="loanAdvancesObj.expand" @click="toggle(loanAdvancesObj)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>LOAN & ADVANCES</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{totalUnsecuredLoanOpening || 0 | amount}}</td>
                  <td style="text-align: right;"><h3 class="green--text"> {{totalLoanAndAdvances || 0 | amount}}</h3></td>
                  <td></td>
                  <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalUnsecuredLoanOpening,totalLoanAndAdvances,0) || 0 | amount}}</td>
                </tr>
                <!-- <template v-if="loanAdvancesObj.expand">
                  <tr>
                    <td><h3></h3>
                      <span style="display: grid;">
                        <v-icon v-if="!loanAdvancesObj.securedLoanObj.expand" @click="toggle(loanObj.securedLoanObj)" color="primary">expand_more</v-icon>
                        <v-icon v-if="loanAdvancesObj.securedLoanObj.expand" @click="toggle(loanObj.securedLoanObj)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    
                    <td><h3>Secured Loans</h3></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                    <td></td>
                    
                    <td><h3 class="red--text"> {{securedLoansBankListTotal || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;"></td>
                </tr>
                <template v-if="loanObj.securedLoanObj.expand">
                  <template v-for="bank in securedLoansBankList" >
                    <tr v-bind:key="bank['.key']" >
                        <td></td>
                        <td><h4>{{bank.bankName}}</h4></td>
                         <td v-if="detailedView" style="text-align: right;"></td>
                        <td></td>
                        <td><b class="red--text"><h4> {{bank.amount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                      </tr> 
                    </template>
                  </template>
                </template> -->
                <template v-if="loanAdvancesObj.expand">
                  <tr>
                    <td><h3></h3>
                      <span style="display: grid;">
                        <v-icon v-if="!loanAdvancesObj.unsecuredLoanAdvancesObj.expand" @click="toggle(loanAdvancesObj.unsecuredLoanAdvancesObj)" color="primary">expand_more</v-icon>
                        <v-icon v-if="loanAdvancesObj.unsecuredLoanAdvancesObj.expand" @click="toggle(loanAdvancesObj.unsecuredLoanAdvancesObj)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    <td style="text-align: left;"><h3>Loans and Advances</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalUnsecuredLoanOpening || 0 | amount}}</td>
                    <td style="text-align: right;"><h3 class="green--text"> {{totalLoanAndAdvances || 0 | amount}}</h3></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalUnsecuredLoanOpening,totalLoanAndAdvances,0) || 0 | amount}}</td>
                </tr>
               <template v-if="loanAdvancesObj.unsecuredLoanAdvancesObj.expand">
                <!-- <template v-for="creditor in sellerList.concat(buyerList)"> -->
                  <template v-for="creditor in buyerList.concat(sellerList)">
                    <tr v-if="!!creditor.totalLoanTaken" :key="creditor['.key']">
                        <td></td>
                        <td><h4 style="text-align: left;">{{creditor['name']}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;">{{creditor.totalOpeningBal || 0 | amount}}</td>
                        <td style="text-align: right;"><b class="green--text"><h4> {{creditor.totalLoanTaken || 0 | amount}}</h4></b></td>
                        <td></td>
                        <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(creditor.totalOpeningBal,creditor.totalLoanTaken,0) || 0 | amount}}</td>
                      </tr> 
                    </template>
                  </template>
                </template>
                <!-- End of Loans and Advances -->

                <!-- fixed Assets -->  
                <tr>
                  <td><h3> 4 </h3>
                    <span style="display: grid;">
                      <v-icon v-if="!fixedAssetsObj.expand" @click="toggle(fixedAssetsObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="fixedAssetsObj.expand" @click="toggle(fixedAssetsObj)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>FIXED ASSETS</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalAssetOpening || 0 | amount}}</td>
                    <td style="text-align: right;"><h3 class="green--text"> {{totalAssetAmount || 0 | amount}}</h3></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalAssetOpening,totalAssetAmount,0) || 0 | amount}}</td>
                </tr>
                <template v-if="fixedAssetsObj.expand">
                  <template  v-for="(asset, e) in getAssetAccount" >
                    <tr v-if="asset.details.type != ('investments' && 'intangibleAssets')"  v-bind:key="e">
                      <td>
                        <h3></h3>
                          <span style="display: grid;">
                          </span>
                          </td>
                          <td style="text-align: left;"><h3>{{ asset.details.asset }} / {{ asset.details.category }} {{ asset.details.type }}</h3></td>
                          <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(asset.details.openingBalance)}}</td>
                          <td style="text-align: right;"><h3 class="green--text">{{ ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )  }}</h3></td>
                          <td></td>
                           <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(asset.details.openingBalance,((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance))),0) || 0 | amount}}</td>
                    </tr> 
                    <template>
                      <template v-for="(section, i) in asset.invoices" >
                        <tr v-bind:key="i">
                          <td></td>    
                          <td><h4>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</h4></td>      
                          <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(section.openingBalance)}}</td>                 
                          <td style="text-align: right;"><b class="green--text"><h4> {{ section.totalAmount || section.openingBalance || 0 | amount}}</h4></b></td>
                          <td></td>
                          <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(section.openingBalance,section.totalAmount,0) || 0 | amount}}</td>
                        </tr> 
                      </template>
                    </template>
                  </template>
                </template>
                <!-- End of Fixed Assets -->

                <!-- Start of Intangible Assets -->  
                <tr>
                  <td><h3> 5 </h3>
                    <span style="display: grid;">
                      <v-icon v-if="!intangibleAssetsObj.expand" @click="toggle(intangibleAssetsObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="intangibleAssetsObj.expand" @click="toggle(intangibleAssetsObj)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>INTANGIBLE ASSETS</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalIntangibleOpening || 0 | amount}}</td>
                    <td  style="text-align: right;"><h3 class="green--text"> {{totalIntangibleAmount || 0 | amount}}</h3></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalIntangibleOpening,totalIntangibleAmount,0) || 0 | amount}}</td>
                </tr>

                <template v-if="intangibleAssetsObj.expand">
                  <template  v-for="(asset, e) in getIntangibleAccount" >
                    <tr v-if="asset.details.type === 'intangibleAssets'"  v-bind:key="e">
                      <td>
                        <h3></h3>
                          <span style="display: grid;">
                          </span>
                          </td>
                          <td style="text-align: left;"><h3>{{ asset.details.asset }} / {{ asset.details.category }} {{ asset.details.type }}</h3></td>
                          <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(asset.details.openingBalance)}}</td>
                          <td  style="text-align: right;"><h3 class="green--text">{{ ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )  }}</h3></td>
                          <td></td>
                           <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(asset.details.openingBalance,(((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)))),0) || 0 | amount}}</td>
                    </tr> 
                     <template>
                          <template v-for="(section, i) in asset.invoices" >
                            <tr  v-bind:key="i">
                                <td></td>                    
                                <td><h4>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</h4></td>      
                                <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(section.openingBalance)}}</td>                 
                                <td  style="text-align: right;"><b class="green--text"><h4> {{ section.totalAmount || section.openingBalance || '-'}}</h4></b></td>
                                <td></td>
                                <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(section.openingBalance,section.totalAmount,0) || 0 | amount}}</td>
                            </tr> 
                            </template>
                        </template>
                    </template>
                </template>
                <!-- End of Intangible Assets -->

                <tr>
                  <td><h3>6</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!investmentsObj.expand" @click="toggle(investmentsObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="investmentsObj.expand" @click="toggle(investmentsObj)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>INVESTMENTS</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{totalInvestmentOpening || 0 | amount}}</td>
                  <td  style="text-align: right;"><h3 class="green--text"> {{totalInvestmentAmount || 0 | amount}}</h3></td>
                  <td></td>
                  <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalInvestmentOpening,totalInvestmentAmount,0) || 0 | amount}}</td>
                </tr>
                <template v-if="investmentsObj.expand">
                  <template v-for="(asset, e) in getInvestmentAccount" >
                    <tr 
                      v-if="asset.details.type === 'investments'"
                      v-bind:key="e">
                        <td><h3></h3>
                          <span style="display: grid;">      
                          </span>
                        </td>
                        <td><h3>{{ asset.details.asset }} / {{ asset.details.category }} {{ asset.details.type }}</h3></td>
                        <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(asset.details.openingBalance)}}</td>
                        <td  style="text-align: right;"><h3 class="green--text">{{ Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0 | amount }}</h3></td>
                        <td></td>
                        <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(asset.details.openingBalance,( Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)),0) || 0 | amount}}</td>
                      </tr> 
                    <template>
                      <template v-for="(section, i) in asset.invoices" >
                        <tr v-bind:key="i">
                          <td></td>
                            <td><h4>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</h4></td>  
                            <td v-if="detailedView" style="text-align: right;">{{Number.parseFloat(section.openingBalance)}}</td>                     
                            <td style="text-align: right;"><b class="green--text"><h4> {{ section.totalAmount || section.openingBalance || '-'}}</h4></b></td>
                          <td></td>
                           <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(section.openingBalance,(section.totalAmount || section.openingBalance ),0) || 0 | amount}}</td>
                        </tr> 
                      </template>
                    </template>
                    </template>
                  </template>
                  
                  <tr>
                    <td><h3>7</h3>
                      <span style="display: grid;">
                        <v-icon v-if="!currentAssetsObj.expand" @click="toggle(currentAssetsObj)" color="primary">expand_more</v-icon>
                        <v-icon v-if="currentAssetsObj.expand" @click="toggle(currentAssetsObj)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    <td style="text-align: left;"><h3>CURRENT ASSETS</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{(Number.parseFloat(totalSundryDebitorsOpening) +Number.parseFloat(cashInHand.totalOpeningBal)+Number.parseFloat(savingsCurrentBankListTotalOpening) )|| 0 | amount}}</td>
                    <td style="text-align: right;"><b class="green--text"><h3> {{(Number.parseFloat(totalSundryDebitors)+ Number.parseFloat(savingsCurrentBankListTotal)+ Number.parseFloat(cashInHand.total)+Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount}}</h3></b></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance((((Number.parseFloattotalSundryDebitorsOpening) +Number.parseFloat(cashInHand.totalOpeningBal)+Number.parseFloat(savingsCurrentBankListTotalOpening) )),((Number.parseFloat(totalSundryDebitors)+ Number.parseFloat(savingsCurrentBankListTotal)+ Number.parseFloat(cashInHand.total)+Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)) ),0) || 0 | amount}}</td>
                  </tr>
                  
                  <template v-if="currentAssetsObj.expand">
                    <tr>
                    <td><h3></h3>
                      <span style="display: grid;">
                        <v-icon v-if="!currentAssetsObj.sundryDebtorsObj.expand" @click="toggle(currentAssetsObj.sundryDebtorsObj)" color="primary">expand_more</v-icon>
                        <v-icon v-if="currentAssetsObj.sundryDebtorsObj.expand" @click="toggle(currentAssetsObj.sundryDebtorsObj)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    <td style="text-align: left;"><h3 class="primary--text">Sundry Debtors</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalSundryDebitorsOpening || 0 | amount}}</td>
                    <td style="text-align: right;"><b class="green--text"><h3> {{totalSundryDebitors || 0 | amount}}</h3></b></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(totalSundryDebitorsOpening,(totalSundryDebitors),0) || 0 | amount}}</td>
                  </tr>
                  <template v-if="currentAssetsObj.sundryDebtorsObj.expand">
                    <template v-for="creditor in buyerList" >
                      <tr v-if="!!creditor.totalRemainingAmount" :key="creditor['.key']"  >
                        <td></td>
                        <td style="text-align: left;"><h4>{{creditor['name']}}</h4></td>
                         <td v-if="detailedView" style="text-align: right;">{{ creditor.totalOpeningBal || 0 | amount}}</td>
                        <td style="text-align: right;"><b class="green--text"><h4> {{ creditor.totalRemainingAmount || 0 | amount}}</h4></b></td>
                        <td></td>
                         <td v-if="detailedView" style="text-align: right;">{{getClosingBalance( creditor.totalOpeningBal,(creditor.totalRemainingAmount ),0) || 0 | amount}}</td>
                      </tr> 
                    </template>
                  </template>
                </template>
                <template v-if="currentAssetsObj.expand">
                  <tr>
                    <td><h3></h3>
                      <span style="display: grid;">
                        <v-icon v-if="!cashInHand.expand" @click="toggle(cashInHand)" color="primary">expand_more</v-icon>
                        <v-icon v-if="cashInHand.expand" @click="toggle(cashInHand)" color="primary">expand_less</v-icon>
                      </span>
                    </td>
                    <td style="text-align: left;"><h3 class="primary--text">Cash in hand</h3></td>
                     <td v-if="detailedView" style="text-align: right;">{{cashInHand.totalOpeningBal|| 0 | amount}}</td>
                    <td  style="text-align: right;"><h3 class="green--text"> {{cashInHand.total || 0 | amount}}</h3></td>
                    <td></td>
                     <td v-if="detailedView" style="text-align: right;">{{getClosingBalance( cashInHand.totalOpeningBal,cashInHand.total,0) || 0 | amount}}</td>
                  </tr>
                  <template v-if="cashInHand.expand">
                    <template v-for="firm of cashInHand.list" >
                      <tr v-bind:key="firm['.key']">
                        <td></td>
                          <td style="text-align: left;"><h4>{{firm.name}}</h4></td>      
                           <td v-if="detailedView" style="text-align: right;">{{firm.openingStock || 0 | amount}}</td>                 
                          <td  style="text-align: right;"><b class="green--text"><h4> {{firm.amount || 0 | amount}}</h4></b></td>
                        <td></td>
                         <td v-if="detailedView" style="text-align: right;">{{getClosingBalance( firm.openingStock,firm.amount,0) || 0 | amount}}</td>
                      </tr> 
                    </template>
                  </template>
                  </template>
                  
                  <template v-if="currentAssetsObj.expand">
                      <tr>
                        <td><h3></h3>
                          <span style="display: grid;">
                            <v-icon v-if="!currentAssetsObj.bankAccountsObj.expand" @click="toggle(currentAssetsObj.bankAccountsObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="currentAssetsObj.bankAccountsObj.expand" @click="toggle(currentAssetsObj.bankAccountsObj)" color="primary">expand_less</v-icon>
                        </span>
                    </td>
                    <td style="text-align: left;"><h3 class="primary--text">Bank accounts</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{savingsCurrentBankListTotalOpening || 0 | amount}}</td>
                    <td  style="text-align: right;"><h3 class="green--text"> {{savingsCurrentBankListTotal || 0 | amount}}</h3></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance( savingsCurrentBankListTotalOpening,savingsCurrentBankListTotal,0) || 0 | amount}}</td>
                </tr>
                 <template v-if="currentAssetsObj.bankAccountsObj.expand">
                    <template  v-for="bank in savingsCurrentBankList" >
                    <tr v-bind:key="bank['.key']">
                        <td></td>
                        <td style="text-align: left;"><h4>{{bank.bankName}}</h4></td> 
                        <td v-if="detailedView" style="text-align: right;">{{ bank.openingBalance || 0 | amount }}</td>                      
                        <td style="text-align: right;"><b class="green--text"><h4> {{ bank.amount || 0 | amount }}</h4></b></td>
                        <td></td>
                        <td v-if="detailedView" style="text-align: right;">{{getClosingBalance( bank.openingBalance,bank.amount,0) || 0 | amount}}</td>
                    </tr> 
                    </template>
                </template>
                </template>
                 <template v-if="currentAssetsObj.expand">
                          <tr>
                    <td><h3></h3>
                        <span style="display: grid;">
                            <v-icon v-if="!currentAssetsObj.gstReceivableObj.expand" @click="toggle(currentAssetsObj.gstReceivableObj)" color="primary">expand_more</v-icon>
                            <v-icon v-if="currentAssetsObj.gstReceivableObj.expand" @click="toggle(currentAssetsObj.gstReceivableObj)" color="primary">expand_less</v-icon>
                        </span>
                    </td>
                    <td style="text-align: left;"><h3>Payable</h3></td>
                    <td v-if="detailedView" style="text-align: right;"></td>
                    <td></td>
                    <td  style="text-align: right;" ><h3 class="red--text"> {{(Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;"></td>
                </tr>
                <template v-if="currentAssetsObj.gstReceivableObj.expand">
                    <template>
                    <tr>
                        <td></td>
                        <td style="text-align: left;"><h4>IGST</h4></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                        <td></td>
                        <td  style="text-align: right;"><b class="red--text"><h4> {{ITCData.assets.IGST || 0 | amount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                    </template>
                       <template>
                    <tr>
                        <td></td>
                        <td style="text-align: left;"><h4>CGST</h4></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                        <td></td>
                        <td  style="text-align: right;" ><b class="red--text"><h4> {{ITCData.assets.CGST || 0 | amount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                    </template>
                       <template>
                    <tr>
                        <td></td>
                        <td style="text-align: left;"><h4>SGST</h4></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                        <td></td>
                        <td style="text-align: right;" ><b class="red--text"><h4> {{ITCData.assets.SGST || 0 | amount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                    </template>
                  </template>
                </template>

                <!-- Sale -->
                <tr>
                  <td><h3>8</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!sale.expand" @click="toggle(sale)" color="primary">expand_more</v-icon>
                      <v-icon v-if="sale.expand" @click="toggle(sale)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td>
                    <h3 style="text-align: left;">SALE</h3>
                  </td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                  <td></td>
                  <td  style="text-align: right;" ><h3 class="red--text"> {{sale.total || 0 | amount }}</h3></td>
                </tr>
                <template v-if="sale.expand">
                  <template v-for="sal of sale.list" >
                    <tr v-bind:key="sal['.key']">
                      <td></td>
                      <td style="text-align: left;"><h4>{{sal.name}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                      <td></td>
                      <td  style="text-align: right;"><b class="red--text"><h4> {{sal.totalAmount || 0 | amount }}</h4></b></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                  </template>
                </template>

                <!-- PURCHASE -->    
                <tr>
                  <td><h3>9</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!purchase.expand" @click="toggle(purchase)" color="primary">expand_more</v-icon>
                      <v-icon v-if="purchase.expand" @click="toggle(purchase)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>PURCHASE</h3></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                  <td  style="text-align: right;" ><h3 class="green--text"> {{purchase.total || 0 | amount }}</h3></td>
                  <td></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                </tr>
                <template v-if="purchase.expand">
                  <template v-for="purchas of purchase.list" >
                    <tr v-bind:key="purchas['.key']">
                      <td></td>
                        <td style="text-align: left;"><h4>{{purchas.name}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                        <td  style="text-align: right;" ><b class="green--text"><h4> {{purchas.totalAmount || 0 | amount}}</h4></b></td>
                      <td></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                  </template>
                </template>
                
                <!-- SALE RETURN -->
                <tr>
                  <td><h3>10</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!saleReturn.expand" @click="toggle(saleReturn)" color="primary">expand_more</v-icon>
                      <v-icon v-if="saleReturn.expand" @click="toggle(saleReturn)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  
                  <td style="text-align: left;"><h3>SALE RETURN</h3></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                    <td  style="text-align: right;" ><h3 class="green--text"> {{saleReturn.total || 0 | amount}}</h3></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;"></td>
                </tr>
                <template v-if="saleReturn.expand">
                  <template v-for="saleRetur of saleReturn.list" >
                    <tr v-bind:key="saleRetur['.key']">
                      <td></td>
                      <td style="text-align: left;"><h4>{{saleRetur.name}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                      <td style="text-align: right;" ><b class="green--text"><h4> {{saleRetur.remainingAmount}}</h4></b></td>
                      <td></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                  </template>
                </template>
                
                
                <!-- Purchase Return --> 
                <tr>
                  <td>
                    <h3>11</h3>
                      <span style="display: grid;">
                        <v-icon v-if="!purchaseReturn.expand" @click="toggle(purchaseReturn)" color="primary">expand_more</v-icon>
                        <v-icon v-if="purchaseReturn.expand" @click="toggle(purchaseReturn)" color="primary">expand_less</v-icon>
                      </span>
                  </td>
                  <td style="text-align: left;"><h3>PURCHASE RETURN</h3></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                  <td></td>
                  <td style="text-align: right;" ><h3 class="red--text"> {{ purchaseReturn.total || 0 | amount }}</h3></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                </tr>
                <template v-if="purchaseReturn.expand">
                  <template v-for="purchaseRetur of purchaseReturn.list" >
                    <tr v-bind:key="purchaseRetur['.key']">
                      <td></td>
                      <td style="text-align: left;"><h4>{{purchaseRetur.name}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                      <td></td>
                      <td style="text-align: right;" ><b class="red--text"><h4> {{purchaseRetur.remainingAmount || 0 | amount }}</h4></b></td>
                      <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                  </template>
                </template>
                
                <!--OLD CODE - BANK -->
                <!-- <tr>
                  <td><h3>3</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!bankObj.expand" @click="toggle(bankObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="bankObj.expand" @click="toggle(bankObj)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td><h3>BANK BALANCE</h3></td>
                    <td><h3 class="green--text"> {{bankObj.total}}</h3></td>
                  <td></td>
                </tr>
                <template v-if="bankObj.expand">
                  <template v-for="bank of bankObj.list" >
                    <tr v-bind:key="bank['.key']">
                      <td></td>
                        <td><h4>{{bank.bankName}}</h4></td>                       
                        <td><b class="green--text"><h4> {{bank.amount}}</h4></b></td>
                      <td></td>
                    </tr> 
                  </template>
                </template> -->

                <!--OLD CODE - DIRECT EXPENSE -->
                <tr>
                  <td><h3>12</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!expensesObj.direct.expand" @click="toggle(expensesObj.direct)" color="primary">expand_more</v-icon>
                      <v-icon v-if="expensesObj.direct.expand" @click="toggle(expensesObj.direct)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>DIRECT EXPENSES</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{expensesObj.direct.totalOpeningBal | amount }}</td>
                    <td  style="text-align: right;" ><h3 class="green--text"> {{expensesObj.direct.total | amount }}</h3></td>
                  <td></td>
                  <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(expensesObj.direct.totalOpeningBal,expensesObj.direct.total,0) || 0 | amount }}</td>
                </tr>
                
                <template v-if="expensesObj.direct.expand">
                  <template v-for="expense of expensesObj.list" >
                    <tr v-if="expense.category == 'Direct'" v-bind:key="expense['.key']">
                      <td></td>
                        <td  style="text-align: left;" ><h4>{{expense.expense}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;">{{expense.openingBalance || 0 | amount }}</td>
                        <!-- <td><b class="green--text"><h4> {{expense.openingBalance | amount  }}</h4></b></td> -->
                        <td  style="text-align: right;" ><b class="green--text"><h4>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}  </h4></b></td> 
                      <td></td>
                      <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(expense.openingBalance,(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance)),0) || 0 | amount }}</td>
                    </tr> 
                  </template>
                </template>

                <!-- OLD CODE - DIRECT INCOME -->
                <tr>
                  <td><h3>13</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!incomes.direct.expand" @click="toggle(incomes.direct)" color="primary">expand_more</v-icon>
                      <v-icon v-if="incomes.direct.expand" @click="toggle(incomes.direct)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3> DIRECT INCOMES</h3></td>
                  <td v-if="detailedView" style="text-align: right;"> {{incomes.direct.totalOpeningBal || 0 | amount}}</td>
                  <td></td>
                  <td  style="text-align: right;" ><h3 class="red--text"> {{incomes.direct.total || 0 | amount}}</h3></td>
                  <td v-if="detailedView" style="text-align: right;"> {{getClosingBalance(incomes.direct.totalOpeningBal,incomes.direct.total,0) || 0 | amount}}</td>
                </tr>
                <template v-if="incomes.direct.expand">
                  <template v-for="income of incomes.list" >
                    <tr v-if="income.category == 'Direct'" v-bind:key="income['.key']">
                      <td></td>
                        <td  style="text-align: left;" ><h4>{{income.income}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;">{{incomes.openingBalance || 0 | amount}}</td>
                        <td></td>
                      <td  style="text-align: right;" ><b class="red--text"><h4> {{income.openingBalance | amount  }}</h4></b></td>
                      <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(income.openingBalance,income.openingBalance,0) || 0 | amount}}</td>
                      <!-- <td><b class="green--text"><h4>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}  </h4></b></td>  -->
                    </tr> 
                  </template>
                </template>

                <!--OLD CODE - INDIRECT EXPENSE -->      
                <tr>
                  <td><h3>14</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!expensesObj.indirect.expand" @click="toggle(expensesObj.indirect)" color="primary">expand_more</v-icon>
                      <v-icon v-if="expensesObj.indirect.expand" @click="toggle(expensesObj.indirect)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>INDIRECT EXPENSES</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{expensesObj.indirect.totalOpeningBal | amount }}</td>
                    <td  style="text-align: right;" ><h3 class="green--text"> {{expensesObj.indirect.total | amount }}</h3></td>
                    <td></td>
                    <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(expensesObj.indirect.totalOpeningBal,expensesObj.indirect.total,0) || 0 | amount }}</td>
                  
                </tr>
                <template v-if="expensesObj.indirect.expand">
                  <template v-for="expense of expensesObj.list" >
                    <tr v-if="expense.category != 'Direct'" v-bind:key="expense['.key']">
                      <td></td>
                      <td  style="text-align: left;" ><h4>{{expense.expense}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;">{{expense.openingBalance || 0 | amount  }}</td>
                      <td  style="text-align: right;" ><b class="green--text"><h4> {{expense.openingBalance || 0 | amount  }}</h4></b></td>
                      <td></td>
                      <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(expense.openingBalance,expense.openingBalance,0) || 0 | amount }}</td>
                      
                      <!-- <td><b class="green--text"><h4>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}  </h4></b></td>  -->
                    </tr> 
                  </template>
                </template>

                <!--OLD CODE - DIRECT INCOME -->
                <tr>
                  <td><h3>15</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!incomes.indirect.expand" @click="toggle(incomes.indirect)" color="primary">expand_more</v-icon>
                      <v-icon v-if="incomes.indirect.expand" @click="toggle(incomes.indirect)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                    <td style="text-align: left;"><h3> INDIRECT INCOMES</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{incomes.indirect.totalOpeningBal || 0 | amount}}</td>
                    <td></td>
                  <td  style="text-align: right;" ><h3 class="red--text"> {{incomes.indirect.total || 0 | amount}}</h3></td>
                  <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(incomes.indirect.totalOpeningBal,incomes.indirect.total,0) || 0 | amount }}</td>
                </tr>
                <template v-if="incomes.indirect.expand">
                  <template v-for="income of incomes.list" >
                    <tr v-if="income.category != 'Direct'" v-bind:key="income['.key']">
                      <td></td>
                      <td style="text-align: left;" ><h4>{{income.income}}</h4></td>
                      <td v-if="detailedView" style="text-align: right;">{{incomes.openingBalance || 0 | amount}}</td>
                      <td></td>
                      <td style="text-align: right;" ><b class="red--text"><h4> {{income.openingBalance || 0 | amount  }}</h4></b></td>
                      <td v-if="detailedView" style="text-align: right;">{{getClosingBalance(incomes.openingBalance,incomes.openingBalance,0) || 0 | amount }}</td>
                      <!-- <td><b class="red--text"><h4> {{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h4></b></td> -->
                    </tr> 
                  </template>
                </template>
                <!-- End Income-->

              <!-- Start Asset -->

              <!-- <tr>
                  <td><h3>6(A)</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!assetsObj.expand" @click="toggle(assetsObj)" color="primary">expand_more</v-icon>
                      <v-icon v-if="assetsObj.expand" @click="toggle(assetsObj)" color="primary">expand_less</v-icon>
                    </span>
                    </td>
                    <td><h3>ASSETS</h3></td>
                    <td><h3 class="green--text"> {{assetsObj.total | amount}}</h3></td>
                  <td></td>
                </tr>
                <template v-if="assetsObj.expand">
                    <template v-for="asset of assetsObj.list" >
                    <tr v-bind:key="asset['.key']">
                        <td></td>
                        <td><h4>{{asset.asset}}</h4></td>
                        <td><b class="red--text"><h4> {{asset.openingBalance | amount  }}</h4></b></td>
                      <td></td>
                    </tr> 
                    </template>
                </template> -->
              <!-- End Asset -->
                
              <!-- <tr>
                  <td><h3>6</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!debtors.expand" @click="toggle(debtors)" color="primary">expand_more</v-icon>
                      <v-icon v-if="debtors.expand" @click="toggle(debtors)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td><h3>DEBTORS</h3></td>
                  <td><h3 class="green--text"> {{debtors.total}}</h3></td>
                  <td></td>
                </tr>
                <template v-if="debtors.expand">
                    <template v-for="debtor of debtors.list" >
                    <tr v-bind:key="debtor['.key']">
                        <td></td>
                        <td><h4>{{debtor.name}}</h4></td>
                        <td><b class="green--text"><h4> {{debtor.remainingAmount}}</h4></b></td>
                        <td></td>
                    </tr>
                    </template>
                </template> -->
                
                <!-- <tr>
                  <td><h3>13</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!creditors.expand" @click="toggle(creditors)" color="primary">expand_more</v-icon>
                      <v-icon v-if="creditors.expand" @click="toggle(creditors)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td><h3>CREDITORS</h3></td>
                    <td></td>
                  <td><h3 class="red--text"> {{creditors.total}}</h3></td>
                </tr>
                <template v-if="creditors.expand">
                  <template v-for="creditor of creditors.list" >
                    <tr v-bind:key="creditor['.key']">
                      <td></td>
                      <td><h4>{{creditor.name}}</h4></td>
                      <td></td>
                      <td><b class="red--text"><h4> {{creditor.remainingAmount}}</h4></b></td>
                    </tr> 
                  </template>
                </template> -->
                
                <!-- <tr>
                    <td>14</td>
                    <td>BANK LOAN</td>
                    <td></td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>15</td>
                    <td>UNSECURE LOAN & ADVANCES</td>
                    <td></td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>17</td>
                    <td>RESERVE & SURPLUS</td>
                    <td></td>
                    <td>-</td>
                </tr> -->
                <tr>
                  <td><h3>16</h3>
                    <span style="display: grid;">
                      <v-icon v-if="!discount.expand" @click="toggle(discount)" color="primary">expand_more</v-icon>
                      <v-icon v-if="discount.expand" @click="toggle(discount)" color="primary">expand_less</v-icon>
                    </span>
                  </td>
                  <td style="text-align: left;"><h3>DISCOUNT RECEIVEABLE</h3></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                  <td></td>
                  <td  style="text-align: right;" ><h3 class="red--text"> {{discount.total || 0 | amount }}</h3></td>
                  <td v-if="detailedView" style="text-align: right;"></td>
                </tr>
                <template v-if="discount.expand">
                    <template v-for="discoun of discount.list" >
                    <tr v-bind:key="discoun['.key']">
                        <td></td>
                        <td><h4>{{discoun.name}}</h4></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                        <td></td>
                        <td><b class="red--text"><h4> {{discoun.discountAmount}}</h4></b></td>
                        <td v-if="detailedView" style="text-align: right;"></td>
                    </tr> 
                    </template>
                </template>
                <!-- <tr>
                    <td>19</td>
                    <td>ACCOUNT PAYABLE</td>
                    <td></td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>INTEREST PAYABLE</td>
                    <td></td>
                    <td>-</td>
                </tr> -->
                <tr>
                  <td></td>
                    <td style="text-align: left;"><h3>TOTAL</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalOpening|| 0 | amount}}</td>
                    <td  style="text-align: right;" ><h3 class="green--text"> {{totalDebit || 0 | amount }}</h3></td>
                    <td  style="text-align: right;" ><h3 class="red--text"> {{totalCredit || 0 | amount}}</h3></td>
                    <td v-if="detailedView" style="text-align: right;">{{totalClosing|| 0 | amount}}</td>
                </tr>
            </tbody>
          </table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
    props: {
        bankByBrand: {type: Array },
    },
  data() {
    return {
      selectedFirm: null,
      toDate: null,
      detailedView : false,
      fromDate: null,
      datepickerFrom: false,
      datepickerTo: false,
      selectedfromDate : null,
      selectedtoDate : null,
      totalSundryCreditors : 0,
      totalSundryDebitors : 0,
      totalSundryDebitorsOpening : 0,
      totalLoan : 0,
      totalLoanAndAdvances : 0,
      buyerList : [],
      sellerList : [],
      expensesWPro : [],
      expenseTotal : 0,
      totalUnsecuredLoanOpening : 0,
      provisionOpeningBal : 0,
      liabilityOpeningBalanace : 0,
      loanObj: {
        expand : false,
        securedLoanObj : {
          expand : false
        },
        unsecuredLoanObj : {
          expand : false
        },
      },
      loanAdvancesObj: {
        expand : false,
        unsecuredLoanAdvancesObj : {
          expand : false
        },
        // securedLoanObj : {
        //   expand : false
        // },
      },
      liabilitiesObj: {
        expand : false,
        sundryCreditorsObj : {
          expand : false
        },
        provisionObj : {
          expand : false
        },
        liabilitiesObj : {
          expand : false
        },
        gstObj : {
          expand : false
        }
      },
      fixedAssetsObj : {
        expand : false
      },
      intangibleAssetsObj : {
        expand : false
      },
      firmObj : {
        total : 0,
        list : [],
        expand : false
      },
      cashInHand : {
        total : 0,
        totalOpeningBal : 0,
        list : [],
        expand : false
      },
      debtors : {
        total : 0,
        list : [],
        expand : false
      },
      creditors : {
        total : 0,
        list : [],
        expand : false
      },
      bankObj : {
        total : 0,
        list : [],
        expand : false
      },
      saleReturn : {
        total : 0,
        list : [],
        expand : false
      },
      purchaseReturn : {
        total : 0,
        list : [],
        expand : false
      },
      expensesObj : {
        total : 0,
        totalOpeningBal : 0,
        list : [],
        direct : {
            expand : false,
            total : 0,
            totalOpeningBal : 0,
        },
        indirect : {
            expand : false,
            total : 0,
            totalOpeningBal : 0,
        }
      },
      incomes : {
        total : 0,
        totalOpeningBal : 0,
        list : [],
        direct : {
            expand : false,
            totalOpeningBal : 0,
            total : 0,
        },
        indirect : {
            expand : false,
            totalOpeningBal : 0,
            total : 0,
        }
      },
      assetsObj : {
        total : 0,
        list : [],
        expand : false
      },
      discount : {
        total : 0,
        list : [],
        expand : false
      },
      sale : {
          total : 0,
          list : [],
          expand : false
      },
      purchase : {
          total : 0,
          list : [],
          expand : false
      },
      investmentsObj : {
        expand : false
      },
      currentAssetsObj : {
        expand : false,
        sundryDebtorsObj : {
          expand : false,
        },
        cashInHandObj : {
          expand : false,
        },
        bankAccountsObj : {
          expand : false,
        },
        gstReceivableObj : {
          expand : false,
        }
      },
      
    };
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("incomesList", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit",  this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
    this.getData();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear"]),
    // firmsByBrand() {
    //   return this.firms.filter(item => item["brand"] === this.selectedBrand);
    // },
    
    // current brands firm list
    firmsByBrand () {
        // return selected brand firms
        let firmsB = this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          firmsB.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
          return firmsB;
      },
    // firmsByBrand () {
		// 	let list = this.firms.filter((item) =>
		// 		item['brand'] === this.selectedBrand
    //   )
    //   .map(item => {
		// 		return {
		// 			text: item['name'],
    //       value: item['.key']
		// 		}
    //   });
    //   if(list.length > 0){
    //     this.updateAndEmit('firms', list[0].value)
    //   }
    //   return list;
    // },
    
    totalDebit(){
      return (
      (this.bankObj.total ? Number.parseFloat(this.bankObj.total) : 0) +
      (this.expensesObj.total ? Number.parseFloat(this.expensesObj.total) : 0)+
      (this.assetsObj.total ? Number.parseFloat(this.assetsObj.total) : 0)+
      //  (this.debtors.total ? Number.parseFloat(this.debtors.total) : 0) + 
      (this.purchase.total ? Number.parseFloat(this.purchase.total) : 0) + 
      (Number.parseFloat(this.totalAssetAmount)) + 
      (Number.parseFloat(this.totalInvestmentAmount)) + 
      (Number.parseFloat(this.totalIntangibleAmount)) + 
      (Number.parseFloat(this.totalSundryDebitors)+ Number.parseFloat(this.savingsCurrentBankListTotal)+ Number.parseFloat(this.cashInHand.total)+Number.parseFloat(this.ITCData.assets.IGST) + Number.parseFloat(this.ITCData.assets.SGST) + Number.parseFloat(this.ITCData.assets.CGST)) + 
      (this.saleReturn.total ? Number.parseFloat(this.saleReturn.total) : 0)).toFixed(2);
    },
    totalCredit(){
      return ((this.firmObj.total ? Number.parseFloat(this.firmObj.total) : 0) +
      (this.sale.total ? Number.parseFloat(this.sale.total) : 0) +
      (this.purchaseReturn.total ? Number.parseFloat(this.purchaseReturn.total) : 0)+
      (this.incomes.total ? Number.parseFloat(this.incomes.total) : 0)+
      // (this.creditors.total ? Number.parseFloat(this.creditors.total):0 )+
      (Number.parseFloat(this.securedLoansBankListTotal + this.totalLoan))+
      (Number.parseFloat(this.liabilityTotal) + Number.parseFloat(this.totalSundryCreditors) + Number.parseFloat(this.expenseTotal) + Number.parseFloat(this.ITCData.liabilities.IGST) + Number.parseFloat(this.ITCData.liabilities.SGST) + Number.parseFloat(this.ITCData.liabilities.CGST)) + 
      (this.discount.total ? Number.parseFloat(this.discount.total):0 )).toFixed(2)
    },
    totalOpening(){
      return ((this.firmObj.total ? Number.parseFloat(this.firmObj.total) : 0) + 
      (this.securedLoansBankListTotalOpening ? Number.parseFloat(this.securedLoansBankListTotalOpening) : 0) +
      (this.totalUnsecuredLoanOpening ? Number.parseFloat(this.totalUnsecuredLoanOpening) : 0) +
      (Number.parseFloat(this.totalUnsecuredLoanOpening) + Number.parseFloat(this.provisionOpeningBal) +Number.parseFloat(this.liabilityOpeningBalanace)) +
      (this.totalUnsecuredLoanOpening ? Number.parseFloat(this.totalUnsecuredLoanOpening) : 0) +
       (this.totalAssetOpening ? Number.parseFloat(this.totalAssetOpening) : 0) +
       (this.totalIntangibleOpening ? Number.parseFloat(this.totalIntangibleOpening) : 0) +
        (this.totalInvestmentOpening ? Number.parseFloat(this.totalInvestmentOpening) : 0) +
        (Number.parseFloat(this.totalSundryDebitorsOpening) +Number.parseFloat(this.cashInHand.totalOpeningBal)+Number.parseFloat(this.savingsCurrentBankListTotalOpening) )+
       (this.expensesObj.totalOpeningBal ? Number.parseFloat(this.expensesObj.totalOpeningBal) : 0) +
       (this.incomes.totalOpeningBal ? Number.parseFloat(this.incomes.totalOpeningBal) : 0)
      )
    },
    totalClosing(){
      return this.getClosingBalance(this.totalOpening ,this.totalDebit,this.totalCredit)
    },
     ITCData(){
        let inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      let outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
        let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
        let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        let filteredInvoices = this.invoices.filter(item => item["brand"] === this.selectedBrand
        && item['items'] 
        && item['items'].length
        && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) 
        && (item.deleted != true) 
        &&  (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true)
        && (this.selectedfromDate ? item.date >= fromDate : true) &&
          (this.selectedtoDate ? item.date <= toDate : true));
        filteredInvoices.map(invoice => {
            if (invoice.isBuyer) {
            invoice.items.map(item => {
              outputGST.SGST += (item.SGST_val && !item.SGST_ITC_paid)
                ? Number.parseFloat(item.SGST_val)
                : 0;
              outputGST.CGST += (item.CGST_val && !item.CGST_ITC_paid)
                ? Number.parseFloat(item.CGST_val)
                : 0;
              outputGST.IGST += (item.IGST_val && !item.IGST_ITC_paid)
                ? Number.parseFloat(item.IGST_val)
                : 0;
            });
          } else {
            invoice.items.map(item => {
              inputGST.SGST += (item.SGST_val && !item.SGST_ITC_paid)
                ? Number.parseFloat(item.SGST_val)
                : 0;
              inputGST.CGST += (item.CGST_val && !item.CGST_ITC_paid)
                ? Number.parseFloat(item.CGST_val)
                : 0;
              inputGST.IGST += (item.IGST_val && !item.IGST_ITC_paid)
                ? Number.parseFloat(item.IGST_val)
                : 0;
            });
          }
        });

        let returnOBJ = {
          liabilities : {
            SGST : 0,
            CGST : 0,
            IGST : 0
          },
          assets : {
            SGST : 0,
            CGST : 0,
            IGST : 0
          }
        }

        //IGST
        if(Number.parseFloat(outputGST.IGST) < Number.parseFloat(inputGST.IGST)) {
          returnOBJ.assets.IGST = (Number.parseFloat(inputGST.IGST) - (Number.parseFloat(outputGST.IGST) + Number.parseFloat(outputGST.CGST) + Number.parseFloat(outputGST.SGST))).toFixed(2)
        } else {
          returnOBJ.assets.IGST = 0;
        } 

        if((Number.parseFloat(outputGST.IGST) > Number.parseFloat(inputGST.IGST))) {
          returnOBJ.liabilities.IGST = (Number.parseFloat(outputGST.IGST) - (Number.parseFloat(inputGST.IGST))).toFixed(2)
        } else {
          returnOBJ.liabilities.IGST = 0;
        } 

        //CGST
        if(Number.parseFloat(inputGST.CGST) > (Number.parseFloat(outputGST.CGST))) {
          returnOBJ.assets.CGST = (Number.parseFloat(inputGST.CGST) - (Number.parseFloat(outputGST.CGST))).toFixed(2)
        } else {
          returnOBJ.assets.CGST = 0;
        } 

        if(Number.parseFloat(inputGST.CGST) < (Number.parseFloat(outputGST.CGST))) {
          returnOBJ.liabilities.CGST = (Number.parseFloat(outputGST.CGST) - Number.parseFloat(inputGST.CGST)).toFixed(2)
        } else {
          returnOBJ.liabilities.CGST = 0;
        }
        
        
        //SGST
        if(Number.parseFloat(inputGST.SGST) > (Number.parseFloat(outputGST.SGST))) {
          returnOBJ.assets.SGST = (Number.parseFloat(inputGST.SGST) - (Number.parseFloat(outputGST.SGST))).toFixed(2) 
        } else {
          returnOBJ.assets.SGST = 0;
        } 

        if(Number.parseFloat(inputGST.SGST) < (Number.parseFloat(outputGST.SGST) )) {
          returnOBJ.liabilities.SGST = ((Number.parseFloat(outputGST.SGST)) - Number.parseFloat(inputGST.SGST)).toFixed(2)
        } else {
          returnOBJ.liabilities.SGST = 0;
        }
        return returnOBJ;

      },
      accountByBrand () {
        const accounts = this.accounts.filter(account => account.brand === this.selectedBrand);
        if(this.selectedFirm) {
          return accounts.filter(account => account.firm === this.selectedFirm['.key'])  
        }
        return accounts
      },
      creditorsById() {
        return this.creditorByBrand.map(item => item['.key'])
      },
      // list customer by Id for diff for invoice 
      customersById() {
        return this.customerByBrand.map(item => item['.key'])
      },
      invoiceByBrandAndFirm () {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => (item['brand'] === this.selectedBrand)
        && (item.deleted != true) 
        && (item.date >= this.finYear.start) && (item.date <= this.finYear.end));
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm['.key']);
        }
        if(this.fromDate) {
          const from = new Date(this.fromDate).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.toDate) {
          const to = new Date(this.toDate).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      // all invoice which are credited
      creditedInvoice() { return this.invoiceByBrandAndFirm.filter(invoice => invoice.isCredited) },
      // all invoice which are debited
      debitedInvoice() { return this.invoiceByBrandAndFirm.filter(invoice => !invoice.isCredited) },
      // expense list type by brand
      expenseByBrand() {
        if(!this.expenses) { return [] };
        // return expense with underhead 
        return this.expenses.filter((item) => item['brand'] === this.selectedBrand).map(item => item['.key']);
      },
      liabilityByBrand() {
        if(!this.liabilities) { return [] };
        // return expense with underhead 
        return this.liabilities.filter((item) => item['brand'] === this.selectedBrand).map(item => item['.key']);
      },
      // expense for which expense type is for brands
      invoiceByExpense() {
        return this.invoiceByBrandAndFirm.filter(invoice => {
          if(invoice.expenseType) {
            return this.expenseByBrand.includes(invoice.expenseType)
          }
          return false
        })
      },
      invoiceByLiability() {
        return this.invoiceByBrandAndFirm.filter(invoice => {
          if(invoice.liabilityType) {
            return this.liabilityByBrand.includes(invoice.liabilityType)
          }
          return false
        })
      },
      // total amount for expense by current brand
      invoiceByExpenseTotal() {
        return this.invoiceByExpense.reduce((total, item) => total + item.totalAmount, 0);
      },
      // total amount for liability by current brand
      invoiceByLiabilityTotal() {
        return this.invoiceByLiability.reduce((total, item) => total + item.totalAmount, 0);
      }, 
      // total Profit income from invoice by brand and firms
      invoiceTotalIncome() {
        return this.invoiceByBrandAndFirm.reduce((total, item) => {
          // calculate total Income for expense
          return total + Number.parseFloat(item['profit'] || 0)
        }, 0)
      },
      // for liabilities
      //  closing balance from net propA/C by firms
      propCapitalAC() {
        if(!this.selectedFirm) {
          return 0;
        }
        return this.selectedFirm.openingBalance
      },
      // all invoice for brand with status "open"
      openInvoices() {
        return this.invoiceByBrandAndFirm.filter(item => item.status === 'open')
      },
      // all invoice by creditors
      openInvoiceByCreditor() {
        const invoice = []
        for(let i = 0; i !== this.openInvoices.length; i++){
          // diff invoice by customeId to creditor
          if(this.creditorsById.includes(this.openInvoices[i].customerId)) {
            invoice.push(this.openInvoices[i])
          }
        }
        return invoice;
      },
      // all invoice by customer (debtors)
      openInvoiceByCustomer() {
        const invoice = []
        for(let i = 0; i !== this.openInvoices.length; i++){
          // diff invoice by customeId to customer
          if(this.customersById.includes(this.openInvoices[i].customerId)) {
            invoice.push(this.openInvoices[i])
          }
        }
        return invoice;
      },
      // creditor invoice where item type is gold/silver
      openInvoiceByCreditorSundry() {
        return this.openInvoiceByCreditor.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver'
          }
          return false
        })
      },
      // creditor invoice where item type is "without item"
      openInvoiceByCreditorUnsecured() {
        return this.openInvoiceByCreditor.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === "Without item"
          }
          return false
        })
      },
      
      // creditor invoice where item type is gold/silver
      openInvoiceByCustomerSundry() {
        return this.openInvoiceByCustomer.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver'
          }
          return false
        })
      },
      // creditor invoice where item type is "without item"
      openInvoiceByCustomerLoanNAdvances() {
        return this.openInvoiceByCustomer.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === "Without item"
          }
          return false
        })
      },
      // Sundry Creditor total: Transaction with item taken by Creditor
      sundryCreditors() {
        return this.openInvoiceByCreditorSundry.reduce((total, item) => total + item.totalAmount, 0)
      },
      sundryCreditorsList() {
        const creditor = {}
        let calculated = []
        try {
          this.openInvoiceByCreditorSundry.forEach(invoice => {
            if(creditor[invoice.customerId]) {
              creditor[invoice.customerId].push(invoice)
            } else {
              creditor[invoice.customerId] = [invoice]
            }
          })
          Object.keys(creditor).forEach(customer => {
            const list = creditor[customer] || []
            calculated.push({
              type: 'creditor',
              invoices: creditor[customer],
              id: customer,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch (e) {
          console.info(e)
          return calculated
        }
        return calculated
      },
      // Creditors Unsecured Loans Total: landing money without item by Creditor
      unsecuredLoans() {
        return this.openInvoiceByCreditorUnsecured.reduce((total, item) => total + item.totalAmount, 0);
      },
      unsecuredLoansList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCreditorUnsecured.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'creditor',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          console.info(e)
        }
        return customerList;
      },
      // Debtors Total: Transaction with item taken by Customer(debtors)
      sundryDebtors() {
        return this.openInvoiceByCustomerSundry.reduce((total, item) => total + item.totalAmount, 0)
      },
      sundryDebtorsList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCustomerSundry.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'customer',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          console.info(e)
        }
        return customerList;
      },
      // landing money without by Customer (debtors)
      loansAndAdvances() {
        return this.openInvoiceByCustomerLoanNAdvances.reduce((total, item) => total + item.totalAmount, 0);
      },
      loansAndAdvancesList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCustomerLoanNAdvances.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'customer',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          console.info(e)
        }
        return customerList;
      },
      // bank with list
      securedLoansBankList() {
        return this.accountByBrand.filter(bank => bank.accountType === 'Loan A/C' || bank.accountType === 'Overdraft A/C')
      },
      // Total of amount of secured loans bank
      securedLoansBankListTotal() {
        return this.securedLoansBankList.reduce((total, bank) => total + bank.amount, 0);
      },
      securedLoansBankListTotalOpening() {
        return this.securedLoansBankList.reduce((openingBalance, bank) => openingBalance + bank.openingBalance, 0);
      },
      // secured account bank list
      savingsCurrentBankList() {
        return this.accountByBrand.filter(bank => bank.accountType === 'Saving A/C' || bank.accountType === 'Current A/C')
      },
      // total of amount of saving/current bank account
      savingsCurrentBankListTotal() {
        return this.savingsCurrentBankList.reduce((total, bank) => total + bank.amount, 0);
      },
      savingsCurrentBankListTotalOpening() {
        return this.savingsCurrentBankList.reduce((total, bank) => Number.parseFloat(total) + Number.parseFloat(bank.openingBalance), 0);
      },
      // cash in hand: firms available cash
        // cashInHand() {
        //   if(this.selectedFirm) {
        //     const firm = this.firmsByBrand.find(firm => firm.value === this.selectedFirm);
        //     return firm.item.amount
        //   }
        //   return this.firmsByBrand.reduce((balance, firm) => {
        //     return balance = balance + firm.item.amount
        //   }, 0)
        // },
      totalAssetAmount() {
        return this.getAssetAccount.reduce((total, item) => {
          return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * (( item.details.depriciation) /100) || 0)  + total
        }, 0)
      },
      totalAssetOpening() {
        return this.getAssetAccount.reduce((total, item) => {
          return (item.details.openingBalance || 0)  + total
        }, 0)
      },
      totalIntangibleAmount() {
        return this.getIntangibleAccount.reduce((total, item) => {
          return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * (( item.details.depriciation) /100) || 0)  + total
        }, 0)
      },
       totalIntangibleOpening() {
        return this.getIntangibleAccount.reduce((total, item) => {
          return (item.details.openingBalance || 0)  + total
        }, 0)
      },
      totalInvestmentAmount() {
        return this.getInvestmentAccount.reduce((total, item) => {
          return item.details.totalAmount + item.details.openingBalance  + total
        }, 0)
      },
      totalInvestmentOpening() {
        return this.getInvestmentAccount.reduce((total, item) => {
          return item.details.openingBalance  + total
        }, 0)
      },
      assetByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type != 'investments' && 'intangibleAssets');
      },
      
      assetAsIntangibleByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type === 'intangibleAssets');
      },
      
      assetAsInvestmentByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type === 'investments');
      },
      invoiceByBrand() {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => (item['brand'] === this.selectedBrand)&& (item.date >= this.finYear.start) && (item.deleted != true)  && (item.date <= this.finYear.end));
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm['.key']);
        }
        if(this.fromDate) {
          const from = new Date(this.fromDate).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.toDate) {
          const to = new Date(this.toDate).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      getAssetAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm['.key']
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices,
                expand : false
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices,
                expand : false
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          console.info(e)
          return []
        }
      },
      
      // Intangible Assets
      getIntangibleAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetAsIntangibleByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm['.key']
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices,
                expand : false
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices,
                expand : false
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          console.info(e)
          return []
        }
      },
      // Investment Assets
      getInvestmentAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetAsInvestmentByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm['.key']
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          console.info(e)
          return []
        }
      },
  },
  methods: {
    toggle(item) {
      item.expand = !item.expand;
    },
    getClosingBalance(opening,debit,credit){
      return ((Number.parseFloat(opening) + Number.parseFloat(debit)) - Number.parseFloat(credit))
    },
    getData(){
        this.propCapital();
        this.getDebtors();
        this.getCreditors();
        this.getBanks();
        this.getSaleReturn();
        this.getPurchaseReturn();
        this.getExpenses();
        this.getIncomes();
        this.getAssets();
        this.usersByBrand();
        this.expenseWithProvision();
        this.liabilityWithProvision();
    },
    getFilteredData(){
      this.getData()
    },
    propCapital(){
        this.firmObj = {
            total : 0,
            list : [],
            expand : false
        }
        this.cashInHand = {
           total : 0,
           totalOpeningBal : 0,
            list : [],
            expand : false
        }
        this.firmObj.list = this.firms.filter(item => item["brand"] === this.selectedBrand
        && (this.selectedFirm ? item[".key"] == this.selectedFirm['.key'] : true));
        this.cashInHand.list = this.firmObj.list;
        this.firmObj.list.map((firm)=>{
            this.firmObj.total += (firm.openingBalance ? Number.parseFloat(firm.openingBalance) : 0);
            this.cashInHand.total += (firm.amount ? Number.parseFloat(firm.amount) : 0);
            this.cashInHand.totalOpeningBal += (firm.openingStock ? Number.parseFloat(firm.openingStock) : 0);
        });
        this.firmObj.total = Number.parseFloat(this.firmObj.total).toFixed(2)
        this.cashInHand.total = Number.parseFloat(this.cashInHand.total).toFixed(2)
        this.cashInHand.totalOpeningBal = Number.parseFloat(this.cashInHand.totalOpeningBal).toFixed(2)
    },
    getDebtors(){
      this.debtors = {
        total : 0,
        list : [],
        expand : false
      };
      this.sale = {
        total : 0,
        list : [],
        expand : false
      };
      this.debtors.list = this.buyers.filter(item => item["brand"] === this.selectedBrand);
      this.sale.list = this.debtors.list;
      this.debtors.list.map((buyer,index)=>{
        let invoices = this.invoices.filter(item => item["brand"] === this.selectedBrand && item['buyerId'] === buyer['.key']
        && (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true)
        && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) 
        && (item.deleted != true)
        && (this.selectedfromDate ? item.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? item.date <= this.selectedtoDat : true));
        let remainingAmountTotal = 0;
        let total = 0;
        invoices.map((invoice)=>{
          this.debtors.total += (invoice.remainingAmount ? Number.parseFloat(invoice.remainingAmount) : 0)
          this.sale.total += (invoice.totalAmount ? Number.parseFloat(invoice.totalAmount) : 0)
          remainingAmountTotal += (invoice.remainingAmount ? Number.parseFloat(invoice.remainingAmount) : 0)
          total += (invoice.totalAmount ? Number.parseFloat(invoice.totalAmount) : 0)
        })
        this.debtors.list[index]['remainingAmount'] = Number.parseFloat(remainingAmountTotal).toFixed(2);
        this.sale.list[index]['totalAmount'] = Number.parseFloat(total).toFixed(2);
      });
      this.debtors.total = Number.parseFloat(this.debtors.total).toFixed(2);
      this.sale.total = Number.parseFloat(this.sale.total).toFixed(2);
    },
    getCreditors() {
      this.creditors = {
        total : 0,
        list : [],
        expand : false
      };
      this.discount= {
        total : 0,
        list : [],
        expand : false
      };
      this.purchase = {
        total : 0,
        list : [],
        expand : false
      };
      this.creditors.list = this.sellers.filter(item => item["brand"] === this.selectedBrand);
      this.discount.list = this.creditors.list;
      this.purchase.list = this.creditors.list;
      this.creditors.list.map((buyer,index)=>{
        let invoices = this.invoices.filter(item => item["brand"] === this.selectedBrand && item['buyerId'] === buyer['.key']
        && (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true)
        && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) 
        && (this.selectedfromDate ? item.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? item.date <= this.selectedtoDat : true));
        let remainingAmountTotal = 0;
        let discount = 0;
        let total = 0;
        invoices.map((invoice)=>{
          this.creditors.total += (invoice.remainingAmount ? Number.parseFloat(invoice.remainingAmount) : 0)
          remainingAmountTotal += (invoice.remainingAmount ? Number.parseFloat(invoice.remainingAmount) : 0)
          discount += (invoice.discountAmount ? Number.parseFloat(invoice.discountAmount) : 0)
          this.discount.total += (invoice.discountAmount ? Number.parseFloat(invoice.discountAmount) : 0)
          total += (invoice.totalAmount ? Number.parseFloat(invoice.totalAmount) : 0)
          this.purchase.total += (invoice.totalAmount ? Number.parseFloat(invoice.totalAmount) : 0)
        })
        this.discount.list[index]['discountAmount'] = (discount? Number.parseFloat(discount).toFixed(2) : 0)
        this.creditors.list[index]['remainingAmount'] = Number.parseFloat(remainingAmountTotal).toFixed(2);
        this.purchase.list[index]['totalAmount'] = Number.parseFloat(total).toFixed(2);
      });
      this.creditors.total = Number.parseFloat(this.creditors.total).toFixed(2)
      this.discount.total = Number.parseFloat(this.discount.total).toFixed(2)
      this.purchase.total = Number.parseFloat(this.purchase.total).toFixed(2)
    },
    getBanks(){
      this.bankObj = {
            total : 0,
            list : [],
            expand : false
        }
        this.bankObj.list = this.bankByBrand.filter(item => (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true))
      
        this.bankObj.list.map((bank)=>{
            this.bankObj.total += (bank.amount ? Number.parseFloat(bank.amount) : 0)
        });
        this.bankObj.total = Number.parseFloat(this.bankObj.total).toFixed(2)
    },
    getSaleReturn() {
      this.saleReturn = {
        total : 0,
        list : [],
        expand : false
      }
      this.saleReturn.list = this.invoices.filter(item => item["brand"] === this.selectedBrand && item['return'] && item['isBuyer'] == true && item['parentInvoice']
      && (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true)
      && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) 
      && (this.selectedfromDate ? item.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? item.date <= this.selectedtoDat : true));
      this.saleReturn.list.map((inv)=>{
        let parentInvoice = this.invoices.filter(item => item['.key'] == inv.parentInvoice)[0];
        inv.remainingAmount = parentInvoice.remainingAmount - inv.remainingAmount;
        this.saleReturn.total += inv.remainingAmount ;
      })
       this.saleReturn.total = Number.parseFloat(this.saleReturn.total).toFixed(2)

    },
    getPurchaseReturn() {
      this.purchaseReturn = {
        total : 0,
        list : [],
        expand : false
      }
      this.purchaseReturn.list = this.invoices.filter(item => item["brand"] === this.selectedBrand && item['return'] && item['isBuyer'] == false && item['parentInvoice']
      && (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true)
      && (item.deleted != true)
      && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) 
      && (this.selectedfromDate ? item.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? item.date <= this.selectedtoDat : true));
      this.purchaseReturn.list.map((inv)=>{
        let parentInvoice = this.invoices.filter(item => item['.key'] == inv.parentInvoice)[0];
        inv.remainingAmount = parentInvoice.remainingAmount - inv.remainingAmount;
        this.purchaseReturn.total += inv.remainingAmount ;
      })
       this.purchaseReturn.total = Number.parseFloat(this.purchaseReturn.total).toFixed(2)
    },
    getExpenses(){
      this.expensesObj = {
        total : 0,
        totalOpeningBal : 0,
        list : [],
        direct : {
          expand : false,
          total : 0,
           totalOpeningBal : 0,
        },
        indirect : {
          expand : false,
          total : 0,
           totalOpeningBal : 0,
        }

      }
      this.expensesObj.list = this.expenses.filter(expense => expense.brand === this.selectedBrand);
          this.expensesObj.list.map((ex,index)=>{
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key']
            && (this.selectedFirm ? invoice["firm"] == this.selectedFirm['.key'] : true)
            && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) 
            && (this.selectedfromDate ? invoice.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? invoice.date <= this.selectedtoDat : true))
            let invoiceOpening = 0;
            invoices.map((inv,index)=>{
              this.expensesObj.list[index]['category'] = ex.category
              invoiceOpening += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
             
            });
            this.expensesObj.list[index]['openingBalance'] = (invoiceOpening ? Number.parseFloat(invoiceOpening).toFixed(2) : 0)
            this.expensesObj.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
            this.expensesObj.totalOpeningBal += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
            if(ex.category == "Direct") {
              this.expensesObj.direct.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
              this.expensesObj.direct.totalOpeningBal += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
            } else {
              this.expensesObj.indirect.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
              this.expensesObj.direct.totalOpeningBal += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
            }
          })
           this.expensesObj.total = Number.parseFloat(this.expensesObj.total).toFixed(2)
           this.expensesObj.direct.total = Number.parseFloat( this.expensesObj.direct.total).toFixed(2)
           this.expensesObj.indirect.total = Number.parseFloat(this.expensesObj.indirect.total).toFixed(2)

           this.expensesObj.totalOpeningBal = Number.parseFloat(this.expensesObj.totalOpeningBal).toFixed(2)
           this.expensesObj.direct.totalOpeningBal = Number.parseFloat( this.expensesObj.direct.totalOpeningBal).toFixed(2)
           this.expensesObj.indirect.totalOpeningBal = Number.parseFloat(this.expensesObj.indirect.totalOpeningBal).toFixed(2)
    },
    getIncomes(){
      this.incomes = {
        total : 0,
         totalOpeningBal : 0,
        list : [],
        direct : {
            expand : false,
            total : 0,
             totalOpeningBal : 0,
        },
        indirect : {
            expand : false,
            total : 0,
             totalOpeningBal : 0,
        }
      }
      this.incomes.list = this.incomesList.filter(income => income.brand === this.selectedBrand);
          this.incomes.list.map((ex,index)=>{
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key']
            && (this.selectedFirm ? invoice["firm"] == this.selectedFirm['.key'] : true)
            && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) 
            && (this.selectedfromDate ? invoice.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? invoice.date <= this.selectedtoDat : true))
            let invoiceOpening = 0;
            invoices.map((inv)=>{
              this.incomes.list[index]['category'] = ex.category
              invoiceOpening += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
            });
            this.incomes.list[index]['openingBalance'] = (invoiceOpening ? Number.parseFloat(invoiceOpening).toFixed(2) : 0)
            this.incomes.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0 )
            this.incomes.totalOpeningBal += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0 )
            if(ex.category == "Direct") {
              this.incomes.direct.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
              this.incomes.direct.totalOpeningBal += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
            } else {
              this.incomes.indirect.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
              this.incomes.indirect.totalOpeningBal += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0)
            }
          })
          this.incomes.total = Number.parseFloat(this.incomes.total).toFixed(2)
          this.incomes.direct.total = Number.parseFloat( this.incomes.direct.total).toFixed(2)
          this.incomes.indirect.total = Number.parseFloat(this.incomes.indirect.total).toFixed(2)

          this.incomes.totalOpeningBal = Number.parseFloat(this.incomes.total).toFixed(2)
          this.incomes.direct.totalOpeningBal = Number.parseFloat( this.incomes.direct.total).toFixed(2)
          this.incomes.indirect.totalOpeningBal = Number.parseFloat(this.incomes.indirect.total).toFixed(2)
    },
    getAssets(){
      this.assetsObj = {
        total : 0,
        list : [],
        expand : false
      }
      this.assetsObj.list = this.assets.filter(asset => asset.brand === this.selectedBrand);
          this.assetsObj.list.map((ex,index)=>{
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["assetType"] === ex['.key']
            && (this.selectedFirm ? invoice["firm"] == this.selectedFirm['.key'] : true)
            && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) 
            && (this.selectedfromDate ? invoice.date >= this.selectedfromDate : true) &&
          (this.selectedtoDate ? invoice.date <= this.selectedtoDat : true))
            let invoiceOpening = 0;
            invoices.map((inv)=>{
              invoiceOpening += ((inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0 ) + (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0))
            });
            this.assetsObj.list[index]['openingBalance'] = (invoiceOpening ? Number.parseFloat(invoiceOpening).toFixed(2) : 0)
            this.assetsObj.total += (invoiceOpening ? Number.parseFloat(invoiceOpening) : 0 )
          })
           this.assetsObj.total = Number.parseFloat(this.assetsObj.total).toFixed(2)
    },
    expenseWithProvision(){
        this.expenseTotal = 0;
        this.provisionOpeningBal = 0;
        let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand);
        expenses = expenses.filter(expense => !!expense['.key']);
        expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => (invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'])
          && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end))
          console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          this.provisionOpeningBal = isNaN(openingBalance) ? this.provisionOpeningBal : Number.parseFloat(this.provisionOpeningBal) + Number.parseFloat(openingBalance);
          if(expenses[index].paymentTypeStatus == 'yet to confirm') {
            console.log(totalAmount)
            this.expenseTotal = isNaN(totalAmount) ? this.expenseTotal : Number.parseFloat(this.expenseTotal) + Number.parseFloat(totalAmount);
          }
        })
        this.provisionOpeningBal = Number.parseFloat(this.provisionOpeningBal);
        this.expenseTotal = Number.parseFloat(this.expenseTotal);
        this.expensesWPro = expenses;
      },
      // Liability With Provision
      liabilityWithProvision(){
        this.liabilityTotal = 0;
        this.liabilityOpeningBalanace = 0;
        let liabilities = this.liabilities.filter(liability => liability.brand === this.selectedBrand);
        liabilities = liabilities.filter(liability => !!liability['.key']);
        liabilities.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => (invoice.brand === this.selectedBrand && invoice["liabilityType"] === ex['.key'])&& (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end))
          console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          liabilities[index].paymentTypeStatus = paymentTypeStatus;
          liabilities[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          liabilities[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          this.liabilityOpeningBalanace = isNaN(openingBalance) ? this.liabilityOpeningBalanace : Number.parseFloat(this.liabilityOpeningBalanace) + Number.parseFloat(openingBalance);
          if(liabilities[index].paymentTypeStatus == 'yet to confirm') {
            console.log(totalAmount)
            this.liabilityTotal = isNaN(totalAmount) ? this.liabilityTotal : Number.parseFloat(this.liabilityTotal) + Number.parseFloat(totalAmount);
          }
        })
        this.liabilityTotal = Number.parseFloat(this.liabilityTotal);
        this.liabilitiesWPro = liabilities;
      },
      usersByBrand() {
        if(this.sellers) {
          this.totalLoan = 0;
          this.totalUnsecuredLoanOpening = 0;
          this.totalLoanAndAdvances = 0;
          this.totalSundryCreditors = 0;
          this.sellerList = this.sellers.filter(customer => customer['brand'] === this.selectedBrand);
          this.sellerList.map((seller,index)=>{
              this.sellerList[index]['totalDiscount'] = 0;
              this.sellerList[index]['totalDueAmount'] = 0;
              this.sellerList[index]['totalAdvance'] = 0;
              this.sellerList[index]['totalSecurity'] = 0;
              this.sellerList[index]['totalOpeningBal'] = 0;
              this.sellerList[index]['totalLoanGiven'] = 0;
              this.sellerList[index]['totalLoanTaken'] = 0;
              let invoices  = this.invoices.filter(
                  item =>
                    item["brand"] === this.selectedBrand &&
                    item["buyerId"] === seller['.key'] &&
                    (item.deleted != true) &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                    (item["status"] === "due" || item["status"] === "partial") &&
                    (this.selectedFirm
                      ? item["firm"] === this.selectedFirm['.key']
                      : true)
                );
              invoices.map((inv) => {
                this.sellerList[index]['totalDueAmount'] += Number.parseFloat(inv.remainingAmount);
                this.sellerList[index]['totalDiscount'] += Number.parseFloat(inv.discountAmount);
              });

              let advanceInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Advance" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              advanceInv.map((inv)  => {
                this.sellerList[index]['totalAdvance'] = inv.remainingAmount;
              });

              let securityInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  item["type"] === "Security" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              securityInv.map((inv)  => {
                this.sellerList[index]['totalSecurity'] = inv.remainingAmount;
              });

              let openingInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  item["type"] === "Opening Balance" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              openingInv.map((inv)  => {
                this.sellerList[index]['totalOpeningBal'] = inv.remainingAmount;
              });

              let loanInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  item["type"] === "LoanGiven" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInv.map((inv)  => {
                this.sellerList[index]['totalLoanGiven'] += Number.parseFloat(inv.amount);
              });

              let loanInvTkn = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  item["type"] === "LoanTaken" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInvTkn.map((inv)  => {
                this.sellerList[index]['totalLoanTaken'] += Number.parseFloat(inv.amount);
              });

              this.totalLoan += Number.parseFloat(this.sellerList[index]['totalLoanGiven']);
              this.totalUnsecuredLoanOpening += Number.parseFloat(this.sellerList[index]['totalOpeningBal']);
              this.totalLoanAndAdvances += Number.parseFloat(this.sellerList[index]['totalLoanTaken']);
             this.sellerList[index]['totalRemainingAmount'] = (Number.parseFloat(this.sellerList[index]['totalOpeningBal']) + Number.parseFloat(this.sellerList[index]['totalDueAmount'])) - (Number.parseFloat(this.sellerList[index]['totalAdvance']) + Number.parseFloat(this.sellerList[index]['totalSecurity']) + Number.parseFloat(this.sellerList[index]['totalDiscount']));
             this.totalSundryCreditors += Number.parseFloat(this.sellerList[index]['totalRemainingAmount']);
          });
        }

        if(this.buyers) {
          this.totalSundryDebitors = 0;
          this.totalSundryDebitorsOpening = 0;
          this.buyerList = this.buyers.filter(customer => customer['brand'] === this.selectedBrand);
          this.buyerList.map((seller,index)=>{
              this.buyerList[index]['totalDiscount'] = 0;
              this.buyerList[index]['totalDueAmount'] = 0;
              this.buyerList[index]['totalAdvance'] = 0;
              this.buyerList[index]['totalSecurity'] = 0;
              this.buyerList[index]['totalOpeningBal'] = 0;
              this.buyerList[index]['totalLoanTaken'] = 0;
              this.buyerList[index]['totalLoanGiven'] = 0;
              this.buyerList[index]['totalRemainingAmount'] = 0;
              let invoices  = this.invoices.filter(
                  item =>
                    item["brand"] === this.selectedBrand &&
                    item["buyerId"] === seller['.key'] &&
                    (item.deleted != true) &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                    (item["status"] === "due" || item["status"] === "partial") &&
                    (this.selectedFirm
                      ? item["firm"] === this.selectedFirm['.key']
                      : true)
                );
              invoices.map((inv) => {
                console.log(this.buyerList[index]['totalDueAmount'])
                this.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? Number.parseFloat(inv.remainingAmount) : 0;
                this.buyerList[index]['totalDiscount'] += inv.discountAmount ? Number.parseFloat(inv.discountAmount) : 0;
              });

              let advanceInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Advance" &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              advanceInv.map((inv)  => {
                this.buyerList[index]['totalAdvance'] = inv.remainingAmount;
              });

              let securityInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Security" &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              securityInv.map((inv)  => {
                this.buyerList[index]['totalSecurity'] = inv.remainingAmount;
              });

              let openingInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Opening Balance" &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              openingInv.map((inv)  => {
                this.buyerList[index]['totalOpeningBal'] = inv.remainingAmount;
              });

              let loanInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "LoanTaken" &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& s
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInv.map((inv)  => {
                this.buyerList[index]['totalLoanTaken'] += Number.parseFloat(inv.amount);
              });

              let loanInvGV = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "LoanGiven" &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end)&& 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInvGV.map((inv)  => {
                this.buyerList[index]['totalLoanGiven'] += Number.parseFloat(inv.amount);
              });

              this.totalLoanAndAdvances += Number.parseFloat(this.buyerList[index]['totalLoanTaken']);
              this.totalLoan += Number.parseFloat(this.buyerList[index]['totalLoanGiven']);
              this.buyerList[index]['totalRemainingAmount'] = (Number.parseFloat(this.buyerList[index]['totalOpeningBal']) + Number.parseFloat(this.buyerList[index]['totalDueAmount'])) - (Number.parseFloat(this.buyerList[index]['totalAdvance']) + Number.parseFloat(this.buyerList[index]['totalSecurity']) + Number.parseFloat(this.buyerList[index]['totalDiscount']));
              this.totalSundryDebitors += Number.parseFloat(this.buyerList[index]['totalRemainingAmount']);
               this.totalSundryDebitorsOpening += Number.parseFloat(this.buyerList[index]['totalOpeningBal']);
          });
        }
      },
    generateAddress(user) {
      let address = "";
      if (user.block) {
        address = `${user.block}`;
      }
      if (user.village) {
        address = `${address ? address + ", " : ""}${user.village}`;
      }
      if (user.tehsil) {
        address = `${address ? address + ", " : ""}${user.tehsil}`;
      }
      if (user.state) {
        address = `${address ? address + ", " : ""}${user.state}`;
      }
      return address;
    },
  },
  watch: {
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getFilteredData();
      }
    },
    toDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        let selectedtoDate = this.toDate ? new Date(this.toDate).getTime() : null;
        this.getFilteredData();
      }
    },
    fromDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.selectedfromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        this.getFilteredData();
      }
    },
    selectedBrand(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getData();
      }
    }
  }
};
</script>

<style >
/* .theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}

.trail-balance .theme--light .v-label {
    color: white;
}

.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
} */

/* .trail-balance .theme--light .v-label {
    color: rgba(255, 255, 255, 255);
} */

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: grey darken !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
    color: #ffffff;
    background: #15155D;
    border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}

.theme--light .filter-switch1 {
  position: absolute;
  right: 20px;
  margin-top: -10px;
}

.theme--light .filter-switch1 .v-label {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/TrailBalanceAccount/TrailBalanceAccount.vue